import { render } from "./PaginationBar.vue?vue&type=template&id=94dfac5a&scoped=true"
import script from "./PaginationBar.vue?vue&type=script&lang=js"
export * from "./PaginationBar.vue?vue&type=script&lang=js"

import "./PaginationBar.vue?vue&type=style&index=0&id=94dfac5a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94dfac5a"]])

export default __exports__